/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetCreate } from '../models/AssetCreate';
import type { AssetRead } from '../models/AssetRead';
import type { AssetUpdate } from '../models/AssetUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AssetsService {
    /**
     * List Assets
     * @returns AssetRead Successful Response
     * @throws ApiError
     */
    public static listAssetsAssetsGet(): CancelablePromise<Array<AssetRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets/',
        });
    }
    /**
     * Create Asset
     * @returns AssetRead Successful Response
     * @throws ApiError
     */
    public static createAssetAssetsPost({
        requestBody,
    }: {
        requestBody: AssetCreate,
    }): CancelablePromise<AssetRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/assets/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Asset
     * @returns AssetRead Successful Response
     * @throws ApiError
     */
    public static getAssetAssetsAssetIdGet({
        assetId,
    }: {
        assetId: number,
    }): CancelablePromise<AssetRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Asset
     * @returns AssetRead Successful Response
     * @throws ApiError
     */
    public static updateAssetAssetsAssetIdPatch({
        assetId,
        requestBody,
    }: {
        assetId: number,
        requestBody: AssetUpdate,
    }): CancelablePromise<AssetRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Asset
     * @returns void
     * @throws ApiError
     */
    public static deleteAssetAssetsAssetIdDelete({
        assetId,
    }: {
        assetId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/assets/{asset_id}',
            path: {
                'asset_id': assetId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
